import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";

const LinkContent = ({ productName, imageUrl }) =>
  imageUrl ? (
    <img alt="" src={imageUrl} />
  ) : (
    <FormattedMessage id={productName} defaultMessage={productName} />
  );

LinkContent.propTypes = {
  productName: PropTypes.string,
  imageUrl: PropTypes.string,
};

const ProductLink = ({ url, externalProductUrl, productName, imageUrl, onClick }) => {
  const Tag = externalProductUrl ? "a" : Link;
  const propKey = externalProductUrl ? "href" : "to";

  return React.createElement(
    Tag,
    {
      [propKey]: url,
      onClick: onClick,
    },
    <LinkContent productName={productName} imageUrl={imageUrl} />
  );
};

ProductLink.propTypes = {
  url: PropTypes.string,
  externalProductUrl: PropTypes.string,
  productName: PropTypes.string,
  imageUrl: PropTypes.string,
  onClick: PropTypes.func,
};

export default ProductLink;



// WEBPACK FOOTER //
// ./components/common/ProductLink.js